<template>
  <div class="vmdtp_body">
    <ul class="vmdtp_list">
      <li
        v-for="year in yearRange"
        :key="`${year}-year`"
        :ref="`${year}-year`"
        :class="{ selected: (parseInt(year) === parseInt(selectedYear))}"
        class="vmdtp_list-item"
        @click.prevent="handleClick(year)"
      >
        {{ year }}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'Year',
  props: {
    yearRange: {
      required: false,
      default: () => {
        const currentYear = new Date().getFullYear()
        const range = 100
        const minYear = currentYear - range
        const yearsRange = []
        for (let i = minYear; i <= minYear + range * 2; i++) {
          yearsRange.push(i)
        }
        return yearsRange
      }
    },
    selectedYear: {
      type: Number,
      required: true
    }
  },
  methods: {
    handleClick (year) {
      this.$emit('year', year)
      this.scroll()
    },
    scroll () {
      const pointYear = this.selectedYear - 3
      const selectedYearElement = this.$refs[`${pointYear}-year`][0]
      if (selectedYearElement && 'scrollIntoView' in selectedYearElement) selectedYearElement.scrollIntoView({ behavior: 'auto' })
    }
  },
  mounted () {
    this.scroll()
  }
}
</script>

<style scoped>
.vmdtp_body {
  height: 290px;
  overflow: auto;
}

.vmdtp_body::-webkit-scrollbar {
  height: 290px;
  overflow: auto;
  width: 5px;
}

.vmdtp_body::-webkit-scrollbar-track {
  height: 290px;
  overflow: auto;
  box-shadow: inset 0 0 5px rgba(84, 84, 84, 0.25);
  border-radius: 10px;
}

.vmdtp_body::-webkit-scrollbar-thumb {
  height: 290px;
  overflow: auto;
  background: #38b7ea;
  border-radius: 10px;
}

.vmdtp_body::-webkit-scrollbar-thumb:hover {
  height: 290px;
  overflow: auto;
  background: darken(#38b7ea, 20%);
}

.vmdtp_list {
  list-style: none;
  padding: 0;
}

.vmdtp_list-item {
  padding: 8px 0;
  text-align: center;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 22px;
}
.vmdtp_list-item:hover {
  padding: 8px 0;
  text-align: center;
  font-family: sans-serif;
  font-size: 16px;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 22px;
  cursor: pointer;
  background-color: rgba(84, 84, 84, 0.1);
}
.vmdtp_list-item.selected {
  text-align: center;
  font-family: sans-serif;
  letter-spacing: 0.1px;
  line-height: 22px;
  font-size: 26px;
  font-weight: 500;
  color: #38b7ea;
  padding: 10px 0;
}
</style>
